<template>
	<div id='' class='gPageBorder' v-loading='loading'>
		<el-form class='gForm' label-position="right" ref="cer" :rules='rules' label-width="12.5%" :model='cer'
			style=''>

			<el-form-item :label="$t('lin_global.certificateName')" prop='name'>
				<el-input v-model='cer.name'></el-input>
			</el-form-item>

			<el-form-item :label="$t('lin_global.remark')" prop=''>
				<el-input v-model='cer.mark'></el-input>
			</el-form-item>

			<el-form-item :label="$t('app_distributor')" prop='' v-show='uploadType == 1'>
				<MechanismSelector :data="mechanismData" :mselect="true" cclasss="'w_33'"></MechanismSelector>
			</el-form-item>

			<!-- app_plsUlPbCer -->
			<el-form-item :label="$t('app_cerFile')" prop='curl'>
				<el-upload name='fileUpload' class="upload-demo" :action="fileUploadUrl" :on-remove="removeFile"
					:before-upload="cerBefore" :on-success="cerSuccess" :file-list="srcList">
					<el-button size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>
					<div slot="tip" class="el-upload__tip">{{$t('app_plsUlPbCer')}}</div>
				</el-upload>
			</el-form-item>

			<el-form-item>
				<el-button type='' style='' @click="cancel">{{$t('app_cancel')}}</el-button>
				<el-button type='primary' style='' @click="submit">{{$t('app_submit')}}</el-button>

			</el-form-item>
		</el-form>

	</div>
</template>

<style>
</style>

<script>
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	export default {
		components: {
			MechanismSelector
		},
		data() {
			var itemCheck = (rule, value, callback) => {
				if (!this.form.item) {
					callback(new Error(this.$t('app_select')));
				} else {
					callback()
				}
			}
			var that = this
			return {
				mechanismData: {
					placeholder: that.$t('lin_global.place_areaid'),
					callback(value) {
						that.cer.mech = value
					}
				},
				uploadType: 0,
				srcList: [],
				loading: 0,
				mechanismId: window.localStorage['mechanismId'],
				dNo: '',
				info: '',
				pushType: [{
						label: this.$t('app_distributor'),
						vl: 0
					},
					{
						label: this.$t('app_dv'),
						vl: 1
					},
				],
				tableData: [],
				fatherList: [],
				mechs: [],
				finalMcId: '',
				cer: {
					name: '',
					mark: '',
					curl: '',
					purl: '',
					mech: ''
				},
				form: {
					item: '',
					pushType: 0,
					mechanism: ''
				},
				rules: {
					name: [{
						required: true,
						message: this.$t('app_input'),
						trigger: 'blur'
					}],
					mark: [{
						required: false,
						message: this.$t('app_input'),
						trigger: 'blur'
					}],
					mech: [{
						required: true,
						message: this.$t('app_selectChannel'),
						trigger: 'blur'
					}],
					curl: [{
						required: true,
						message: this.$t('app_plsUlPbCer'),
						trigger: 'blur'
					}]
				}
			}
		},
		destroyed() {
			this.$setWObj('cnUploadId', '')
		},
		// beforeRouteEnter(to, from, next) {
		//   if (from.path == '/channels/channel-detail') {

		//   } else {
		//     alert('normal')
		//   }
		//   next()
		// },
		computed: {
			fileUploadUrl() {
				// var vl = this.$filePbCerUploadUrl
				var vl = "https://tmsadmin.szzt.com.cn/file-management/tms-server-web/sgn/fileupload.do"
				return vl
			}
		},
		methods: {
			removeFile() {
				this.cer.curl = ''
				this.cer.purl = ''
				this.srcList = []
				this.hBlur('cer')
			},
			hBlur(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {} else {
						return false
					}
				})
			},
			cancel() {
				this.$router.go(-1)
			},
			cerBefore(file) {
				// console.log(file)
				window[this.$route.path] = 1
			},
			cerSuccess(res, file) {
				// console.log(res)
				window[this.$route.path] = ''
				if (res.status === 200) {
					this.cer.curl = res.cer_url
					this.cer.purl = res.privkey_url
					this.srcList = [{
						name: file.name
					}]
					this.hBlur('cer')
				} else {
					this.$message.error(res.message)
					this.srcList = []
				}
			},
			submit() {
				this.$refs['cer'].validate((valid) => {
					if (valid) {

						var fmech = ''
						if (this.uploadType === 1) {
							if (!this.cer.mech) {
								this.$message(this.$t('app_plslchannel'))
								return
							}
							fmech = this.cer.mech
						} else {
							fmech = this.finalMcId
						}

						this.loading = 1
						var purl = this.cer.purl ? this.cer.purl : ''
						var curl = this.cer.curl ? this.cer.curl : ''
						this.$uploadCer(curl, purl, this.cer.id, this.cer.name, this.cer.mark, fmech, (res) => {
							this.loading = 0
							if (res.status === 200) {
								this.$message.success(res.message)
								this.$router.go(-1)
								/*this.cer = {}
								this.srcList = []*/
							} else {
								this.$message.error(res.message)
							}
						}, () => {
							this.loading = 0
						})

					} else {
						return false
					}
				})
			},
			fwChange(vl) {
				// console.log(vl)
			}
		},
		mounted() {


			this.uploadType = this.$getWObj().safeCerType

			var outId = this.$getWObj().cnUploadId
			if (outId) {
				this.finalMcId = outId
			} else {
				this.finalMcId = localStorage.mechanismId
			}
		}
	}
</script>


// WEBPACK FOOTER //
// cerUpload.vue?2e6c6cc1